import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from '@che-ins-ui/input';
import { InputError } from '@/components/common/InputError';
import { PassengerField } from '@/models/forms/interface';
import { isFormDirtySelector, } from '@/models/forms/selectors';
import { setPassengerName } from '@/models/forms/setPassengerName';
import { formsActions } from '@/models/forms';
import { formatNameOnBlur } from '@/models/forms/helpers';
import { inputLabels, inputNames, inputPlaceholders } from '../consts';
import { useIsMobileInputSuggestions, useIsMobileViewInsuranceForm, } from '../../hooks';
import { PASSENGERS_MAX_LAYOUT_ANIMATION_DURATION } from './Passengers';
import { PassengerBirthday } from './PassengerBirthday';
import { useStyles } from './styles';
export const Passenger = memo(({ index, _uuid, firstName, lastName, birthday, fieldsErrors, fieldsDirty, }) => {
    const isFormDirty = useSelector(isFormDirtySelector);
    const classes = useStyles();
    const dispatch = useDispatch();
    const tourisNameRef = useRef(null);
    const [previewSuccess, setPreviewSuccess] = useState(false);
    const isMobileFormView = useIsMobileViewInsuranceForm();
    const isMobileSuggestionsView = useIsMobileInputSuggestions();
    const animationOrigin = useCallback((origin) => isMobileFormView ? { originY: origin } : { originX: origin }, [isMobileFormView]);
    const getFormError = (field) => (isFormDirty || fieldsDirty[field]) && fieldsErrors[field];
    const formErrors = {
        lastName: getFormError(PassengerField.lastName),
        firstName: getFormError(PassengerField.firstName),
        birthday: getFormError(PassengerField.birthday),
    };
    const setFieldDirty = (field) => dispatch(formsActions.setPassengerFieldDirty({ field, _uuid }));
    const setFieldNameValue = (field, value) => dispatch(setPassengerName({ _uuid, field, value }));
    return (_jsxs(motion.div, { className: classes.passenger, layout: "position", initial: {
            opacity: 0.4,
            scale: 0.5,
            ...animationOrigin(0),
        }, animate: {
            opacity: 1,
            scale: 1,
            ...animationOrigin(0.5),
        }, exit: {
            opacity: 0.4,
            scale: 0.6,
            ...animationOrigin(1),
        }, transition: {
            opacity: { duration: 0.2 },
            layout: {
                duration: Math.min((index + 1) * 0.1, PASSENGERS_MAX_LAYOUT_ANIMATION_DURATION),
            },
        }, children: [_jsxs("div", { style: { position: 'relative' }, ref: tourisNameRef, children: [_jsx(Input, { value: lastName, onChange: (value) => setFieldNameValue(PassengerField.lastName, value), name: inputNames.lastName, label: inputLabels.lastName, shouldFitContent: true, placeholder: inputPlaceholders.lastName, invalid: Boolean(formErrors.lastName), onBlur: () => {
                            setFieldDirty(PassengerField.lastName);
                            setFieldNameValue(PassengerField.lastName, formatNameOnBlur(lastName));
                        } }), _jsx(InputError, { error: formErrors.lastName })] }, "lastname"), _jsxs("div", { children: [_jsx(Input, { value: firstName, onChange: (value) => setFieldNameValue(PassengerField.firstName, value), name: inputNames.firstName, label: inputLabels.firstName, shouldFitContent: true, placeholder: inputPlaceholders.firstName, invalid: Boolean(formErrors.firstName), onBlur: () => {
                            setFieldDirty(PassengerField.firstName);
                            setFieldNameValue(PassengerField.firstName, formatNameOnBlur(firstName));
                        } }), _jsx(InputError, { error: formErrors.firstName })] }, "firstname"), _jsx(PassengerBirthday, { _uuid: _uuid, birthday: birthday, errorMessage: formErrors.birthday }, "birthday")] }));
});
